

























































































import { Observer } from 'mobx-vue'
import { Component, Provide, Vue } from 'vue-property-decorator'
import { FarmsViewModel } from '@/modules/farming/viewmodels/farms-viewmodel'
import { walletStore } from '@/stores/wallet-store'

@Observer
@Component({
  components: {
    'multi-logo': () => import('@/components/multi-logo/multi-logo.vue')
  }
})
export default class extends Vue {
  @Provide() vm = new FarmsViewModel()
  walletStore = walletStore

  goToDetail(farmType, locktime) {
    this.$router.push(`/farm?farmType=${farmType}&locktime=${locktime}`)
  }
}
